<template>
  <div>
    <CubePage type="myorder-view" title="开团寻导" :backurl="'distributor'">
      <div slot="content">
        <van-sticky :offset-top="44">
          <van-search placeholder="请输入团队名称" v-model="row.search" @search="onSearch" show-action>
            <div slot="action" @click="onSearch">
              <van-button type="primary">搜索</van-button>
            </div>
          </van-search>
          <van-swipe :loop="false" :width="60" :height="30" :show-indicators="false" style="margin-left:10px;"
            class="hd">
            <van-swipe-item style="width: auto" v-for="(item, index) in orderStatusList" :key="index">
              <van-button :class="row.status == item.value ? 'van-button-active' : ''" @click="onTagBtn(item.value)"
                plain round size="mini" style="font-size: 12px;">{{ item.text }}</van-button>
            </van-swipe-item>
          </van-swipe>
          <div class="cal-box">
            <div class="cal-sc">
              <div class="title">出团时间</div>
              <div class="cals" @click="calshow = true">
                <span class="ri" v-if="row.use_date_start">{{ row.use_date_start }}</span>
                <span v-else style="color: #9e9e9e; font-size: 12px;">选择开始日期</span>
                <van-icon name="notes-o" size="25" />
              </div>
              <div class="dj">到</div>
              <div class="cals" @click="calshow = true">
                <span class="ri" v-if="row.use_date_end">{{ row.use_date_end }}</span>
                <span v-else style="color: #9e9e9e; font-size: 12px;">选择结束日期</span>
                <van-icon name="notes-o" size="25" />
              </div>
            </div>
            <van-swipe :loop="false" :width="60" :height="30" :show-indicators="false" style="margin-left:10px;"
              class="hd">
              <van-swipe-item style="width: auto">
                <van-button :class="selectcaltag == '全部' ? 'van-button-active' : ''" @click="onTagCalBtn('全部')" plain
                  round size="mini" style="font-size: 12px;">全部</van-button>
              </van-swipe-item>
              <van-swipe-item style="width: auto">
                <van-button :class="selectcaltag == '今天' ? 'van-button-active' : ''" @click="onTagCalBtn('今天')" plain
                  round size="mini" style="font-size: 12px;">今天</van-button>
              </van-swipe-item>
              <van-swipe-item style="width: auto">
                <van-button :class="selectcaltag == '明天' ? 'van-button-active' : ''" @click="onTagCalBtn('明天')" plain
                  round size="mini" style="font-size: 12px;">明天</van-button>
              </van-swipe-item>
              <van-swipe-item style="width: auto">
                <van-button :class="selectcaltag == '后天' ? 'van-button-active' : ''" @click="onTagCalBtn('后天')" plain
                  round size="mini" style="font-size: 12px;">后天</van-button>
              </van-swipe-item>
              <van-swipe-item style="width: auto">
                <van-button :class="selectcaltag == '近7天' ? 'van-button-active' : ''" @click="onTagCalBtn('近7天')" plain
                  round size="mini" style="font-size: 12px;">近7天</van-button>
              </van-swipe-item>
              <van-swipe-item style="width: auto">
                <van-button :class="selectcaltag == '近两周' ? 'van-button-active' : ''" @click="onTagCalBtn('近两周')" plain
                  round size="mini" style="font-size: 12px;">近两周</van-button>
              </van-swipe-item>
            </van-swipe>
          </div>
        </van-sticky>

        <div style="z-index: -10;" class="orderlist">
          <van-empty v-if="isNoData" class="custom-image" description="您还没有相关的订单">
            <template #image>
              <img src="@/assets/img/empty.png" alt>
            </template>
          </van-empty>
          <van-pull-refresh v-else v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad()"
              :immediate-check="false">
              <div class="orderitem van-clearfix" v-for="(item, index) in OrderList" :key="index" @click="goDetail(item.id, 'detail')">
                <div class="ordertitle">
                  <p>团队名称：{{ item.team_name }}</p>
                  <p class="colorred">
                    <span>{{ item.status_text }}</span>
                  </p>
                </div>
                <van-card :num="1">
                  <template #price-top>
                    <div class="carflex">
                      <div class="carddesc">
                        <span>出团时间：</span>
                        <span>{{ item.start_time }}</span>
                      </div>
                      <div class="carddesc">
                        <span>完团时间：</span>
                        <span>{{ item.end_time }}</span>
                      </div>
                      <div class="carddesc">
                        <span>天数：</span>
                        <span>{{ item.days }}</span>
                      </div>
                      <div class="carddesc">
                        <span>人数：</span>
                        <span>{{ item.team_number }}</span>
                      </div>
                      <div class="carddesc">
                        <span>团队类型：</span>
                        <span>{{ item.team_type_text }}</span>
                      </div>
                      <div class="carddesc">
                        <span>职级：</span>
                        <span>{{ item.guide_rank_text }}</span>
                      </div>
                      <div class="carddesc">
                        <span>价格：</span>
                        <span>{{ item.total_price }}</span>
                      </div>
                      <div class="carddesc">
                        <span>状态：</span>
                        <span>{{ item.status_text }}</span>
                      </div>
                      <div class="carddesc" v-if="item.nickname != null">
                        <span>导游：</span>
                        <span>{{ item.nickname }}</span>
                      </div>
                      <div class="carddesc" v-if="item.phone != null">
                        <span>联系电话：</span>
                        <span>{{ item.phone }}</span>
                      </div>
                    </div>
                  </template>
                  <template #footer>
                    <div style="margin-top: 10px;">
                      <van-button style="border-radius: 4px;" size="small" type="info" v-if="item.status == 10 || item.status == 11"
                        @click.stop="goDetail(item.id, 'edit')">编辑</van-button>
<!--                      <van-button style="border-radius: 4px;" size="small" type="primary"
                        @click="goDetail(item.id, 'detail')">详情</van-button>-->
                    </div>
                  </template>
                </van-card>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
        <div class="footer-btn">
          <van-button round block icon="plus" color="linear-gradient(to right, #ff6034, #ee0a24)"
            @click="onAddOrder">发布</van-button>
        </div>
      </div>
    </CubePage>
    <cube-view></cube-view>
    <SelectZf ref="selectZf" />
    <van-calendar v-model="calshow" type="range" @confirm="onConfirm" :allow-same-day="true" :min-date="minDate" />
  </div>
</template>


<script>
import CubeView from "@/components/TP/cube-view";
import CubePage from "../../TP/cube-page.vue";
import SelectZf from '../../NewPages/selectzf.vue'
import * as udate from "@/utils/date";
import * as util from "@/utils/network";

export default {
  components: {
    CubePage,
    CubeView,
    SelectZf
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      OrderList: [],
      isNoData: false,
      pageIndex: 1,
      pageTotal: 0,
      selectcaltag: "",
      calshow: false,
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(),
      row: {
        status: "",
        search: "",
        use_date_start: "",
        use_date_end: ""
      },
      orderStatusList: [{
        text: '全部',
        value: ''
      },
      {
        text: '待审核',
        value: '10'
      },
      {
        text: '待确认',
        value: '12'
      },
      {
        text: '进行中',
        value: '14'
      },
      {
        text: '已完成',
        value: '16'
      }],
    };
  },
  created() {
    this.get_my_order();
  },
  methods: {
    // 新增
    onAddOrder() {
      this.$router.push({
        path: '/travelAdd'
      })
    },
    // 跳转详情页
    goDetail(id, type) {
      let url = type == 'edit' ? '/travelAdd' : '/travelDetailNew';
      console.log(url);
      this.$router.push({
        path: url,
        query: {
          id: id,
        }
      })
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      let that = this;
      that.clearContainer();
      const [start, end] = date;
      that.calshow = false;
      that.row.use_date_start = that.formatDate(start);
      that.row.use_date_end = that.formatDate(end);
      that.get_my_order();
    },
    onTagCalBtn(v) {
      let that = this;
      if (that.selectcaltag == v) {
        return;
      }
      this.clearContainer();
      let start = "";
      let end = "";
      let fmt = "yyyy/MM/dd";
      start = udate.getDatenow(fmt);
      switch (v) {
        case "今天":
          end = that.GetDateStr(0, fmt);
          break;
        case "明天":
          start = that.GetDateStr(1, fmt);
          end = that.GetDateStr(1, fmt);
          break;
        case "近7天":
          end = that.GetDateStr(7, fmt);
          break;
        case "后天":
          start = that.GetDateStr(2, fmt);
          end = that.GetDateStr(2, fmt);
          break;
        case "近两周":
          end = that.GetDateStr(14, fmt);
          break;
        case "全部":
          end = "";
          start = "";
          break;
        default:
          end = "";
          break;
      }
      that.row.use_date_start = start;
      that.row.use_date_end = end;
      that.selectcaltag = v;
      that.get_my_order();
    },
    onTagBtn(v) {
      let that = this;
      if (that.row.status == v) {
        return;
      }
      that.row.status = v;
      that.onSearch();
    },
    onSearch() {
      this.clearContainer();
      this.pageIndex = 1;
      this.get_my_order();
    },
    // 上滑加载更多
    onLoad() {
      let that = this;
      // 异步更新数据
      setTimeout(() => {
        that.pageIndex++;
        if (that.OrderList < 1 || that.finished) return;
        if (that.refreshing) {
          that.OrderList = [];
          that.pageIndex = 1;
          that.refreshing = false;
        }
        that.get_my_order();
      }, 1000);
    },
    // 获取数据
    get_my_order() {
      var url = "/addons/litestore/api.distributor/guiderReserve";
      let that = this;
      that.loading = true;
      that.row.page = that.pageIndex;
      console.log(that.row)
      let { page, search, use_date_end, use_date_start, status } = that.row;
      let obj = {
        team_name: search,
        status,
        page,
        start_time: use_date_start,
        end_time: use_date_end,
        limit: 10
      }
      console.log(obj)
      //这里直接调用网络接口
      util.post(url, that.row, function (result) {
        //这里对状态 进行分类
        that.pageTotal = result.data.total;
        console.log(that.pageTotal, "1111111111");
        if (that.pageTotal < 1) {
          // that.finished = true;
          that.isNoData = true;
          return;
        } else {
          that.isNoData = false;
        }
        that.loading = false;
        if (result.data.list == null || result.data.list.length === 0) {
          // 加载结束
          that.finished = true;
          return;
        }
        // 将新数据与老数据进行合并
        that.OrderList = that.OrderList.concat(result.data.list);
        // console.log(that.isNoData)
        //如果列表数据条数>=总条数，不再触发滚动加载
        if (that.OrderList.length >= that.pageTotal) {
          that.finished = true;
        }
      });
    },
    GetDateStr(AddDayCount) {
      var day = new Date();
      day.setDate(day.getDate() + AddDayCount); //获取AddDayCount天后的日期
      var y = day.getFullYear();
      var m = day.getMonth() + 1; //获取当前月份的日期
      var d = day.getDate();
      m = String(m < 10 ? "0" + m : m);
      d = String(d < 10 ? "0" + d : d);

      return y + "/" + m + "/" + d;
    }, // 初始化数据
    clearContainer() {
      let that = this;
      that.loading = false;
      that.finished = false;
      that.refreshing = false;
      that.OrderList = [];
      that.isNoData = false;
      that.pageIndex = 1;
      that.pageTotal = 0;
    },
    //下拉刷新
    onRefresh() {
      this.finished = false;
      this.onLoad();
    }
  }
};
</script>
<style lang="less" type="text/css">
.van-sticky {
  background: #fafafa !important;
}
</style>
<style lang="less" scoped="scoped">
@import url("../../../assets/css/order.css");
@import url("../../../assets/css/listboxless.less");

.van-search {
  .van-search__action {
    line-height: 0;
  }

  .van-button {
    height: 34px;
  }
}

.hd {
  .van-button {
    flex-shrink: 0;
    margin-right: 6px;
  }

  .van-button-active {
    border: 1px solid #55aa7f;
    color: #55aa7f;
  }

}

.van-button--mini {
  padding: 0 10px !important;
}



.cal-box {
  background-color: #ffffff;
}

.cal-sc {
  margin-top: 10px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;

  .title {
    color: #989898;
    padding-right: 10px;
  }

  .dj {
    margin: 0 5px;
  }

  .cals {
    .ri {
      font-weight: 600;
    }

    .van-icon {
      color: #55aa7f;
      margin-left: 10px;
      vertical-align: middle;
    }
  }

}

.footerflex {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 5px 0;
  color: #ff0000;
  font-size: 14px;
}

.hxdialog {
  border-bottom: 1px solid #eeeeee;
  border-top: 1px solid #eeeeee;

  .van-card__title {
    font-size: 15px;
    padding-bottom: 5px;
  }

  .carddesc,
  .van-card__num {
    font-size: 13px;
    padding: 3px 0;
  }
}

.contentsheet {
  padding: 16px 16px 20px;
  margin: 0;

  .btnmini {
    width: 100%;
    text-align: right;
    padding-top: 16px;

    .van-button--small {
      width: 70px;
    }
  }
}
</style>
<style type="text/css" lang="less" scoped="scoped">
.van-card {
  background: transparent !important;
}

.slide {
  overflow-x: auto;
  white-space: nowrap;
  box-sizing: border-box;

  .slide-item {
    display: inline-block;
    width: 100px;
    height: 100px;
    background-color: #ccc;
    margin-right: 10px;
  }
}

.carflex {
  flex-flow: wrap;

  .carddesc {
    width: 50%;
  }
}

.footer-btn {
  position: fixed;
  left: 5%;
  bottom: 30px;
  width: 90%;
}

.van-card__num {
  display: none;
}
.orderlist {
  padding-bottom: 100px;
}
</style>
